/* eslint-disable no-unused-vars */
import React, {  useState, useRef } from "react";
import styled from "styled-components/macro";
import {  NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,

  Paper as MuiPaper,
  TextField,
  Typography,

  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ technologies, brands }) {
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [loader, setLoader] = useState(false);
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (name, description, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/plate_inventory/brand`,
        {
          name,
          description,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        navigate("/dashboard/inventory/view-brands", {
          state: { success: true, message: "Brand Created Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };
  return (
    <>
      <Formik
        initialValues={{
          name: "",
          description: "",
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Brand Name is required"),
          description: Yup.string().required("Description is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values.name, values.description, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Brand created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Create Brand
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="name"
                          value={values.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.name && errors.name)}
                          id="search-field"
                          label="Brand Name"
                          helperText={touched.name && errors.name}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          name="description"
                          fullWidth
                          value={values.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(
                            touched.description && errors.description
                          )}
                          id="search-field"
                          label="Description"
                          helperText={touched.description && errors.description}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Create Brand
                        </Button>
                        {/* <Button
                        style={{ textAlign: "center", background: "red" }}
                        mr={2}
                        variant="contained"
                        color="primary"
                      >
                        Reset
                      </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

function AddBrand() {
  const [loader, setLoader] = useState(false);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CREATE BRAND
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory/view-brands">
                Brands
              </Link>
              <Typography>Create Brand</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default AddBrand;
